import Vue from 'vue'

const eventHub = new Vue()

Vue.mixin({
    data()
    {
        return {
            eventHub
        }
    }
})



// WEBPACK FOOTER //
// ./src/scripts/mixins/core-event-hub/index.js